export default __webpack_public_path__ + "static/media/blend.177acd26.svg";